var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0666 7.15035V12.8503C18.0666 13.7837 17.5666 14.6504 16.7583 15.1254L11.8083 17.9837C10.9999 18.4504 9.99993 18.4504 9.18326 17.9837L4.23326 15.1254C3.42493 14.6587 2.92493 13.792 2.92493 12.8503V7.15035C2.92493 6.21702 3.42493 5.35032 4.23326 4.87532L9.18326 2.01699C9.99159 1.55033 10.9916 1.55033 11.8083 2.01699L16.7583 4.87532C17.5666 5.35032 18.0666 6.20869 18.0666 7.15035Z",
    stroke: "#0B1526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 9.16651C11.5722 9.16651 12.4416 8.29719 12.4416 7.22483C12.4416 6.15248 11.5722 5.2832 10.4999 5.2832C9.42754 5.2832 8.55823 6.15248 8.55823 7.22483C8.55823 8.29719 9.42754 9.16651 10.4999 9.16651Z",
    stroke: "#0B1526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 13.8836C13.8333 12.3836 12.3416 11.167 10.5 11.167C8.65829 11.167 7.16663 12.3836 7.16663 13.8836",
    stroke: "#0B1526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patient-icon.1ed619e43de8fa8132b3238c15869865.svg";
export { ForwardRef as ReactComponent };